// extracted by css-extract-rspack-plugin
var _1 = "filter-bQsSym";
var _2 = "table-jeTJ7_";
export { _1 as "filter", _2 as "table" }
